export default __webpack_public_path__ + "static/media/bg_02.867ac445.png";